var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from "react";
import styled from "styled-components";
import { Paper, Typography, Grid } from "@material-ui/core";
import { removeFalseIsNotTrue } from "../services/test_parsing";
var StyledPaper = styled(function (_a) {
  var passed = _a.passed,
    props = __rest(_a, ["passed"]);
  return React.createElement(Paper, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-left: 10px solid ", ";\n  margin: 5px;\n  padding: 10px;\n"], ["\n  border-left: 10px solid ", ";\n  margin: 5px;\n  padding: 10px;\n"])), function (_a) {
  var passed = _a.passed;
  return passed ? "#4caf50" : "#f44336";
});
var TestResultHeader = styled(function (_a) {
  var passed = _a.passed,
    props = __rest(_a, ["passed"]);
  return React.createElement(Typography, __assign({}, props));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 700;\n"], ["\n  color: ", ";\n  font-weight: 700;\n"])), function (_a) {
  var passed = _a.passed;
  return passed ? "#4caf50" : "#f44336";
});
var TestResult = function (_a) {
  var testName = _a.testName,
    passed = _a.passed,
    feedback = _a.feedback;
  var nameMatch = testName.match(/(\w+)\.(\w+)$/);
  var displayName = nameMatch ? nameMatch[1] + ": " + nameMatch[2] : testName;
  var passStatus = passed ? "PASS" : "FAIL";
  return React.createElement(StyledPaper, {
    passed: passed,
    "data-cy": "test-result"
  }, React.createElement(TestResultHeader, {
    passed: passed
  }, passStatus, ": ", displayName), React.createElement("pre", {
    style: {
      whiteSpace: "pre-wrap",
      wordWrap: "break-word"
    }
  }, removeFalseIsNotTrue(feedback)));
};
var TestResults = function (_a) {
  var results = _a.results,
    showAllTests = _a.showAllTests,
    children = _a.children;
  var showResults = function () {
    if (!showAllTests) {
      var failedTest = results.testCases.find(function (result) {
        return result.passed === false;
      });
      if (failedTest) {
        return React.createElement(TestResult, {
          key: failedTest.id,
          testName: failedTest.testName,
          passed: failedTest.passed,
          feedback: failedTest.feedback
        });
      }
    }
    var testResults = results.testCases.map(function (r) {
      return React.createElement(TestResult, {
        key: r.id,
        testName: r.testName,
        passed: r.passed,
        feedback: r.feedback
      });
    });
    return React.createElement(React.Fragment, null, showAllTests && testResults);
  };
  if (!results.testCases || results.testCases.length === 0) return null;
  return React.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "space-between"
  }, React.createElement(Grid, {
    item: true,
    xs: 12
  }, children, showResults()));
};
export default TestResults;
var templateObject_1, templateObject_2;